import FingerprintJS, { type Agent } from '@fingerprintjs/fingerprintjs'

/**
 * FingerprintJS で visitor id を取得するヘルパー。
 *
 * - 単一の Agent インスタンスをモジュール内でキャッシュ
 * - OSS 版なので精度に限界（プライベートブラウジング等で別人扱い）
 *   → UI 側で「同じブラウザでアクセスしてください」と注意書きを出す
 */

let agentPromise: Promise<Agent> | null = null

export async function getVisitorId(): Promise<string> {
  if (!agentPromise) {
    agentPromise = FingerprintJS.load()
  }
  const agent = await agentPromise
  const result = await agent.get()
  return result.visitorId
}
